import { useEffect, useState } from 'react';
import { Grid, publish } from '@ltvco/refresh-lib';
import { StyledLinkAction, StyledLink } from './components';
import { useHeaderContext } from 'context/HeaderContext';

const bumperMarketplaceUrl = 'https://www.bumper.com/marketplace';

export function SearchLinks() {
  const [searchType, setSearchType] = useState<string | null>(null);
  const { handleSetCurrentDropdown } = useHeaderContext();
  let timeoutId: ReturnType<typeof setTimeout>;

  const openVehicleSearchForm = (type: string) => {
    // TODO: remove publish
    handleSetCurrentDropdown('search');
    publish('openVehicleSearch');
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      setSearchType(type);
    }, 100);
  };

  useEffect(() => {
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    if (searchType) {
      publish(`open${searchType}Search`);
      // this is to reset the search type after the search form is opened
      // so that the search form can be opened again by clicking on the same link
      // without having to click on another link first
      // the useEffect will only run when the searchType changes
      setSearchType(null);
    }
  }, [searchType]);

  return (
    <>
      <Grid item xs={12} sm={3}>
        <StyledLinkAction
          onClick={() => openVehicleSearchForm('Vin')}
          id="footer-vin-search-link"
        >
          VIN Search
        </StyledLinkAction>
      </Grid>
      <Grid item xs={12} sm={3}>
        <StyledLinkAction
          onClick={() => openVehicleSearchForm('Plate')}
          id="footer-plate-search-link"
        >
          License Plate Search
        </StyledLinkAction>
      </Grid>
      <Grid item xs={12} sm={3}>
        <StyledLinkAction
          onClick={() => openVehicleSearchForm('YMM')}
          id="footer-ymm-search-link"
        >
          Year Make Model Search
        </StyledLinkAction>
      </Grid>
      <Grid item xs={12} sm={3}>
        <StyledLink to={bumperMarketplaceUrl} target="_blank">
          Marketplace Search
        </StyledLink>
      </Grid>
    </>
  );
}
